//@flow

export const isShareAPISupported = 'share' in navigator
